$(function() {
    $('.btn-toggle-menu').click(function(e) {

        $(this).toggleClass('active');
        
        $('.toggle-menu').slideToggle();
    });
});

$(function() {
    $('.btn-toggle-specialties').click(function(e) {

        $(this).toggleClass('active');
        
        $('.toggle-menu-specialties').slideToggle();
    });
});
